"use strict";

var Dispatcher = require('flux').Dispatcher;

var originalDispatch = Dispatcher.prototype.dispatch;

Dispatcher.prototype.dispatch = function () {
	if (this._isDispatching) {
		// HACK: does not guarantee ordering of dispatches
		var dispatchArguments = arguments;
		var timer = setInterval(() => {
			if (!Dispatcher._isDispatching) {
				clearInterval(timer);
				originalDispatch.apply(this, dispatchArguments);
			}
		}, 100);
	} else {
		originalDispatch.apply(this, arguments);
	}
};

module.exports = new Dispatcher();
